import { HOME } from "@constants/routes";
import { Link } from "react-router-dom";

const NotFound404 = () => (
  <div className="not-found">
    <div className="not-found__content">
      <p className="code">404</p>
      <h3 className="not-found__info">
        Ooops! The page you are looking for could not be found
      </h3>
      <Link className="btn btn-primary" to={HOME}>
        <span className="lnr lnr-chevron-left" /> Back to home
      </Link>
    </div>
  </div>
);

export default NotFound404;
